import SimpleLightbox from "simplelightbox/dist/simple-lightbox.esm"
import "simplelightbox/dist/simple-lightbox.min.css"

new SimpleLightbox('.lightbox', { /* options */ });